import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    agreementDrawer: css({
        '.MuiDrawer-paper': {
            overflow: 'hidden',
            alignItems: 'flex-start',
            borderRadius: '15px 15px 0px 0px',
            background: 'white',
            maxHeight: '95%',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    }),

    header: css({
        display: 'flex',
        flexShrink: '0',
        alignSelf: 'stretch',
        padding: '32px 20px 10px 20px',
    }),

    closeIcon: css({
        marginLeft: 'auto',
    }),

    content: css({
        overflowY: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        maxWidth: '100%',
        overflowX: 'hidden',
        '::-webkit-scrollbar': {
            display: 'none',
        },
    }),
};
